// Minimal service worker registration for PWA installability + offline
// support. Registered in every environment (not just production builds):
// the SW itself is network-first everywhere except the explicit offline
// fallback branches, so it never serves stale content while online and
// does not interfere with dev-server hot reload (HMR runs over a
// WebSocket, which fetch-based SW interception never touches).
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
